"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _printableWorksheets = require("printableWorksheets");
var _react = _interopRequireWildcard(require("react"));
var _events = _interopRequireDefault(require("./events"));
var _state = require("./state");
var _DownloadedScreen = _interopRequireDefault(require("./components/views/DownloadedScreen"));
var _SavedScreen = _interopRequireDefault(require("./components/views/SavedScreen"));
var _SearchScreen = _interopRequireDefault(require("./components/views/SearchScreen"));
var _AppMediaProvider = require("../baseStyles/AppMediaProvider");
var _Printables = _interopRequireDefault(require("./components/views/Printables"));
require("./styles.scss");
var _common = require("apps/teacher/config/common");
var _wsPreview = _interopRequireDefault(require("./components/worksheetsView/wsPreview"));
var _baseUrls = _interopRequireDefault(require("apps/teacher/config/baseUrls"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PrintableWorksheetsView = function PrintableWorksheetsView() {
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    activeGrade = _usePrintableWorkshee.activeGrade,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment,
    onboardingGrade = _usePrintableWorkshee.onboardingGrade,
    activeScreen = _usePrintableWorkshee.activeScreen,
    envProps = _usePrintableWorkshee.envProps;
  var _useAppMediaProvider = (0, _AppMediaProvider.useAppMediaProvider)(),
    currentDevice = _useAppMediaProvider.currentDevice,
    isMobile = _useAppMediaProvider.isMobile,
    isDesktop = _useAppMediaProvider.isDesktop;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    showWorksheetPreview = _useState2[0],
    setShowWorksheetPreview = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    wsDetailsViaOnboarding = _useState4[0],
    setWsDetailsViaOnboarding = _useState4[1];
  (0, _react.useEffect)(function () {
    if ((0, _common.hasSignedUpFromWs)() && (0, _common.isSignedUpFromWsDetail)() && isDesktop) {
      localStorage.setItem('wsPreviewShownViaOnboarding', 'true');
      var schoolUiHost = (0, _common.isFlutterUser)() ? window.parent.parent.SCHOOL_UI_ASSET_HOST : window.SCHOOL_UI_ASSET_HOST;
      var ws_details = JSON.parse(localStorage.getItem('ws_details'));
      var fromWsList = localStorage.getItem("clickedWsFromListPage");
      var signupPageUrl = fromWsList ? localStorage.getItem("wsLinkUrl") : sessionStorage.getItem('signup_page_url') || '';
      var imageUrl = _baseUrls["default"].cms_image_asset_url + signupPageUrl + '.jpeg';
      var gradesAndStandard = ws_details.ws_grade_tags;
      var subject = ws_details.ws_subject_tag;
      var topics = ws_details.ws_topic_tags;
      var pdf_folder = "https://".concat(schoolUiHost.includes("staging") ? "f2" : "www", ".splashlearn.com/worksheet_uploads/pdf/");
      var obj = {
        id: ws_details.ws_id,
        title: ws_details.ws_title,
        description: ws_details.ws_description,
        image_url: imageUrl,
        grades: gradesAndStandard,
        subject_and_topics: [subject].concat(_toConsumableArray(topics)),
        pdf_url: pdf_folder + signupPageUrl + '.pdf',
        code: ws_details.ws_code
      };
      setWsDetailsViaOnboarding(obj);
      if (window.parent.triggerIsFlutterHeaderClickDisabled) {
        window.parent.triggerIsFlutterHeaderClickDisabled();
      }
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (worksheetsEnvironment) {
      fireMountEvent();
      if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD && isMobile) {
        document.body.style.margin = "0px";
        document.body.style.height = "100%";
      }
    }
  }, [worksheetsEnvironment]);
  var fireMountEvent = function fireMountEvent() {
    switch (worksheetsEnvironment) {
      case _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD:
        {
          var props = {
            worksheetGrade: activeGrade
          };
          _events["default"].clickedWorksheetTab(props);
        }
        break;
      case _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD:
        {
          var _envProps$params, _envProps$params$sett;
          var _props = {
            dashboardVersion: envProps === null || envProps === void 0 ? void 0 : (_envProps$params = envProps.params) === null || _envProps$params === void 0 ? void 0 : (_envProps$params$sett = _envProps$params.settings) === null || _envProps$params$sett === void 0 ? void 0 : _envProps$params$sett.tileDashboardVersion,
            tabCode: envProps === null || envProps === void 0 ? void 0 : envProps.activeHeaderTabId,
            grade: onboardingGrade,
            from: '',
            worksheetCode: ''
          };
          _events["default"].viewedTiledDashboard(_props);
        }
    }
  };
  var activeScreenToBeDisplayed = (0, _react.useMemo)(function () {
    switch (activeScreen) {
      case _state.PRINTABLE_WORKSHEET_SCREENS.DEFAULT:
        return /*#__PURE__*/_react["default"].createElement(_Printables["default"], null);
      case _state.PRINTABLE_WORKSHEET_SCREENS.SAVED:
        return /*#__PURE__*/_react["default"].createElement(_SavedScreen["default"], null);
      case _state.PRINTABLE_WORKSHEET_SCREENS.DOWNLOADED:
        return /*#__PURE__*/_react["default"].createElement(_DownloadedScreen["default"], null);
      case _state.PRINTABLE_WORKSHEET_SCREENS.SEARCH:
        return /*#__PURE__*/_react["default"].createElement(_SearchScreen["default"], null);
      default:
        return /*#__PURE__*/_react["default"].createElement(_Printables["default"], null);
    }
  }, [activeScreen]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showWorksheetPreview && (0, _common.isSignedUpFromWsDetail)() && isDesktop && /*#__PURE__*/_react["default"].createElement(_wsPreview["default"], {
    worksheetDetails: wsDetailsViaOnboarding,
    setShowWorksheetPreview: setShowWorksheetPreview,
    showWorksheetPreview: showWorksheetPreview
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "printable-worksheets device-".concat(currentDevice, " w-env-").concat(worksheetsEnvironment),
    ref: function ref(_ref) {
      if (_ref && !isMobile) {
        var elementDetails = _ref.getBoundingClientRect();
        _ref.style.height = "calc(100vh - ".concat(elementDetails.top + 20, "px)");
      }
    }
  }, activeScreenToBeDisplayed));
};
var _default = PrintableWorksheetsView;
exports["default"] = _default;